
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'bromhidrosis',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/bromhidrosis.vue